const ECOMMERCE_API_URL = process.env.NEXT_PUBLIC_ECOMMERCE_API_URL
	? process.env.NEXT_PUBLIC_ECOMMERCE_API_URL?.endsWith('/')
		? process.env.NEXT_PUBLIC_ECOMMERCE_API_URL
		: `${process.env.NEXT_PUBLIC_ECOMMERCE_API_URL}/`
	: undefined;

export const getEcommerceUrl = (): string => {
	const ecommerceUrl = process.env.NEXT_PUBLIC_ECOMMERCE_API_URL;
	return ecommerceUrl;
};

const PORTAL_API_URL = process.env.NEXT_PUBLIC_PORTAL_API_URL
	? process.env.NEXT_PUBLIC_PORTAL_API_URL?.endsWith('/')
		? process.env.NEXT_PUBLIC_PORTAL_API_URL
		: `${process.env.NEXT_PUBLIC_PORTAL_API_URL}/`
	: undefined;

export const getEcommerceUrlEquipment = (): string => {
	const portalUrl = process.env.NEXT_PUBLIC_PORTAL_API_URL;
	return portalUrl;
};

// Add CHECKOUT_API_URL here.
const CHECKOUT_API_URL = process.env.NEXT_PUBLIC_CHECKOUT_API_URL
	? process.env.NEXT_PUBLIC_CHECKOUT_API_URL?.endsWith('/')
		? process.env.NEXT_PUBLIC_CHECKOUT_API_URL
		: `${process.env.NEXT_PUBLIC_CHECKOUT_API_URL}/`
	: undefined;

export const getCheckoutUrl = (): string => {
	const checkoutUrl = process.env.NEXT_PUBLIC_CHECKOUT_API_URL;
	return checkoutUrl;
};

// Add COMMERCEMEDIA_API_URL here.
const COMMERCEMEDIA_API_URL = process.env.NEXT_PUBLIC_COMMERCEMEDIA_API_URL
	? process.env.NEXT_PUBLIC_COMMERCEMEDIA_API_URL?.endsWith('/')
		? process.env.NEXT_PUBLIC_COMMERCEMEDIA_API_URL
		: `${process.env.NEXT_PUBLIC_COMMERCEMEDIA_API_URL}/`
	: undefined;

export const getCommerceMediaUrl = (): string => {
	const checkoutUrl = process.env.NEXT_PUBLIC_COMMERCEMEDIA_API_URL;
	return checkoutUrl;
};

const DOMAIN_PROTOCOL = process.env.DOMAIN_PROTOCOL ?? 'https';
const DOMAIN_PORT = process.env.DOMAIN_PORT;

const CONTENT_API_URL = process.env.NEXT_PUBLIC_CONTENT_API_URL;

// And CHECKOUT_API_URL added here below!
export { ECOMMERCE_API_URL, PORTAL_API_URL, DOMAIN_PROTOCOL, DOMAIN_PORT, CONTENT_API_URL, CHECKOUT_API_URL, COMMERCEMEDIA_API_URL };
